/* CreateComponent.js */

"use strict";
const BaseCreateComponent = require("../../../../lib/actions/components/create/BaseCreateComponent");

class CreateComponent extends BaseCreateComponent {
    constructor(logger, title, message, value) {
        super(logger, title || "Create Plan", message, "Enter OS Plan Name", value);
    }
}

module.exports = CreateComponent;
